import React, { useState, useEffect } from 'react';
import '../../styles/AdminModal.css';
import { updateCategory } from '../../services/AdminCategoryService';
import CategoryEditForm from '../../forms/categories/CategoryEditForm';
import { validateCategory } from '../../validations/admin/AdminCategoryValidation';

const CategoryEditModal = ({ isOpen, onClose, onSuccess, category }) => {
  const [formData, setFormData] = useState({
    name: '',
    is_default: false
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const isFormValid = formData.name.trim() !== '';
  const hasChanges = category && (
    category.name !== formData.name ||
    category.is_default !== formData.is_default
  );

  useEffect(() => {
    if (category) {
      setFormData({
        name: category.name || '',
        is_default: category.is_default || false
      });
      setErrors({});
      setError('');
    }
  }, [category]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSave = async () => {
    const validationErrors = validateCategory(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    setErrors({});
    setError('');
    try {
      await updateCategory(category.id, formData);
      await onSuccess();
      onClose();
    } catch (error) {
      console.error('Error updating category:', error);
      setError(error.message || 'Error updating category. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Edit Category</h2>
          <button className="admin__modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}
        <div className="admin__modal-body">
          <CategoryEditForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
          />
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Saving...' : 'Cancel'}
          </button>
          <button
            className="button"
            onClick={handleSave}
            disabled={loading || !isFormValid || !hasChanges}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryEditModal;